import React from 'react';
import { styled } from 'baseui';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';
import { LabelMedium, LabelSmall } from 'baseui/typography';
import { StatusGroup } from '../../../utils/dashboardUtils';

const ChartContainer = styled('div', {
  backgroundColor: '#fff',
  borderRadius: '8px',
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
  padding: '20px',
  minHeight: '400px',
  display: 'flex',
  flexDirection: 'column',
});

const ChartHeader = styled('div', {
  marginBottom: '16px',
});

const CenterLabel = styled('div', {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  textAlign: 'center',
  pointerEvents: 'none',
});

interface StatusDistributionChartProps {
  data: StatusGroup[];
}

export const StatusDistributionChart: React.FC<StatusDistributionChartProps> = ({ data }) => {
  const total = data.reduce((sum, item) => sum + item.count, 0);

  return (
    <ChartContainer>
      <ChartHeader>
        <LabelMedium margin={0}>Status Distribution</LabelMedium>
      </ChartHeader>
      <div style={{ position: 'relative' }}>
        <ResponsiveContainer width="100%" height={300}>
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              innerRadius={60}
              outerRadius={100}
              paddingAngle={2}
              dataKey="count"
              nameKey="status"
              label={({ percentage }) => `${percentage.toFixed(1)}%`}
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip
              formatter={(value: number, name: string, props: any) => [
                `${value} (${props.payload.percentage.toFixed(1)}%)`,
                props.payload.status
              ]}
            />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
        <CenterLabel>
          <LabelMedium margin={0}>{total}</LabelMedium>
          <LabelSmall color="#6b7280">Total</LabelSmall>
        </CenterLabel>
      </div>
    </ChartContainer>
  );
};
